import { render } from "./AudienceChatModeration.vue?vue&type=template&id=c3f96c26"
import script from "./AudienceChatModeration.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceChatModeration.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceChatModeration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3f96c26"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3f96c26', __exports__)) {
    api.reload('c3f96c26', __exports__)
  }
  
  module.hot.accept("./AudienceChatModeration.vue?vue&type=template&id=c3f96c26", () => {
    api.rerender('c3f96c26', render)
  })

}


export default __exports__